<template id="">
  <div class="">
      <div class="content-thread clearfix">
        <el-col class="left">
          <ul style="overflow:auto;height:780px;">
            <li v-for="(item,index) in xcList" @click="seeThread(index)"><p style="width:500px;">{{item.threadName}}:{{item.threadState}}</p></li>
          </ul>
        </el-col>
        <el-col class="right">
          <div class="title-right" id="title-right">
            <el-col class="log-flex" style="width:270px;">
                <span style="width:53px;display:inline-block;" class="demonstration">日期：</span>
                <el-input style="width:210px;" placeholder="2019-01-01 00:00:00" suffix-icon="el-icon-date" v-model="form.date"></el-input>
            </el-col>
            <el-col style="width:380px;" :offset="1">
              <span style="width:70px;display:inline-block;" class="demonstration">节点ID：</span>
              <el-input style="width:210px;" placeholder="请输入Node ID" v-model="form.node"></el-input>
              <el-button type="primary" style="margin-left:20px;" @click="search">查询</el-button>
            </el-col>
          </div>
          <div class="content-right">
            <p v-for="(item,index) in xlList">{{item}}</p>
          </div>
        </el-col>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'thread',
    data() {
      return {
        form:{
          date:'',
          node:''
        },
        xcList:[],
        xlList:[],
      }
    },
    mounted(){

    },
    methods: {
      seeThread(e){
        var index = e;
        this.xlList = this.xcList[index].threadInfo;
      },
      search(){

        let params = {
            queryTime:this.form.date,
            nodeID:this.form.node
        };
        // params = Object.assign(params,this.form);
        params = this.$qs.stringify(params,{ indices: false });
        var _this = this;
        this.axios({
            method:'post',
            url:window.API_HOST+'/node/selectNodeThread',
            data:params,
        }).then((res)=>{
          console.log(res.data)
          if(res.data.threadInfo.length == "0"){
            this.$message({
              message: res.data.errorMsg,
              type: 'warning'
            });
            return;
          }
          document.getElementById("title-right").style.cssText = "top:10px !important;transition:1s all;-webkit-transition:1s all;";
          this.xcList = res.data.threadInfo;
          this.xlList = this.xcList[0].threadInfo;
        })
      }
    },
  }
</script>
<style scoped lang="scss">
  html,body{
    width: 100%;
  }
  .content-thread{
    margin-top: 0 !important;
    position: relative;
    background-color: #FFF;
    -webkit-box-shadow: #B7C7FF 0px 0px 20px;
    min-height: 780px;
    height: 780px;
    box-shadow: #B7C7FF 0px 0px 20px;
  }
  .right{
    width: 85%;
    .title-right{
      position: absolute;
      width: 73%;
      background: #FFF;
      padding-left: 12%;
      text-align: center;
      top: 48%;
      height: 40px;
    }
    .content-right{
      margin-top: 53px;
      padding-left: 50px;
      padding-top: 20px;
      p{
        margin: 8px 0;
      }
    }
  }
  .left{
    width: 15%;
    background: #FFF;
    border-right: 1px solid #EEE;
    ul{
      li{
        height: 30px;
        line-height: 30px;
      }
      li:nth-child(2n+1){
        p{
          background: #F4F4F4;
        }
      }
      li p:hover{
        cursor: pointer;
        color: #FFF;
        background: #999;
      }
    }
  }
</style>
